import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {PageNames} from '../../../shared/page-names.enum';
import {EmitterConstants} from '../../../shared/emitter-constants';
import {Emitter} from '../../../shared/utils/emitter/emitter';
import {OrderFailedComponent} from '../../ordering-modals/order-failed/order-failed.component';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {Error} from '../../../model/error';
import {OmapiIdConstants} from '../../../shared/omapi-id-constants';

@Component({
  selector: 'app-trial-activation-pending-modal',
  templateUrl: './trial-activation-pending-modal.component.html',
  styleUrls: ['./trial-activation-pending-modal.component.less']
})
export class TrialActivationPendingModalComponent extends OrderFailedComponent implements OnInit {

  componentName = PageNames.TRIAL_ACTIVATION_PENDING;
  @Input()
  trialOmapiId: string;

  constructor(protected navigationService: NavigationService, protected changeDetector: ChangeDetectorRef) {
    super(navigationService, changeDetector);
  }

  onEmitClosePendingFailed() {
    Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.componentName);
  }

  onBack(): void {
    Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.componentName);
  }

  setLabel(error: Error): void {
    this.label = 'eos-tv-shop-ii.text.order-message';
  }

  trialName(): string {
    return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.trialOmapiId);
  }
}
